import { INDIAN_STATES_AND_UTS } from '@/constants/constants';
import { Input, Select } from '@chakra-ui/react';
import * as Yup from 'yup';
import { FormFieldComponentType } from './types';
import { LiveModeRequestFormData } from './hooks/useLiveMSAFormSubmission';

export const validationSchema = Yup.object().shape({
  gstNumber: Yup.string().matches(
    /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/,
    'Invalid GST Number format',
  ),
  pan: Yup.string()
    .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN format')
    .required('Pan Number is required'),

  companyName: Yup.string()
    .min(2, 'Company name must be at least 2 characters')
    .max(100, 'Company name must be less than 100 characters')
    .required('Company name is required'),

  state: Yup.string(),

  city: Yup.string()
    .min(2, 'City name must be at least 2 characters')
    .max(50, 'City name must be less than 50 characters'),

  zipCode: Yup.string().matches(/^\d{6}$/, 'Zip Code must be a 6-digit number'),
});

export const formFields: Array<{
  label: string;
  name: keyof LiveModeRequestFormData;
  component: FormFieldComponentType;
  placeholder: string;
  required?: boolean;
  options?: Array<{ value: string; label: string }>;
}> = [
  {
    label: 'Company Name',
    name: 'companyName',
    component: Input,
    placeholder: 'Enter Legal Name',
    required: true,
  },
  {
    label: 'Pan Number',
    name: 'pan',
    component: Input,
    placeholder: 'Enter Pan Number',
    required: true,
  },
  {
    label: 'GST Number',
    name: 'gstNumber',
    component: Input,
    placeholder: 'Enter GST Number',
  },
  {
    label: 'State',
    name: 'state',
    component: Select,
    options: INDIAN_STATES_AND_UTS.map(state => ({ value: state, label: state })),
    placeholder: 'Select State',
  },
  {
    label: 'City',
    name: 'city',
    component: Input,
    placeholder: 'Enter City Name',
  },
  {
    label: 'Zip Code',
    name: 'zipCode',
    component: Input,
    placeholder: 'Enter Zip Code',
  },
];

export const getInitialValues = (): LiveModeRequestFormData =>
  formFields.reduce(
    (acc, { name }) => {
      return { ...acc, [name]: '' };
    },
    { companyName: '' },
  );
